import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
//引入elementui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 全局引入echarts
import *as echarts from 'echarts'


import store from './store'
// 运行proxy代理
axios.defaults.baseURL = '/api'

import "./assets/styles/reset.scss"
import "./assets/text/text.css"
Vue.config.productionTip = false
Vue.use(ElementUI,{zIndex:9999})
Vue.prototype.$echarts=echarts
// window.progessData=true;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
